(function () {
    'use strict';

    $(window).on('load', function (e) {

        let hash = document.location.hash;
        let targetSection = $(hash);

        // Animate to section on link click
        if ( targetSection && targetSection.length ) {

            $('html, body').animate({
                scrollTop: targetSection.offset().top - ( $('header').innerHeight() + 100 )
            }, 800, function () {
                // window.location.hash = hash;
            });

            e.preventDefault();
            return false;
        }
    });

    $(document).ready(function () {

        var iconSVGElements = document.querySelectorAll(".vivus-icon svg");
        for (var i = iconSVGElements.length - 1; i >= 0; i--) {
            new Vivus(iconSVGElements[i], {duration: 150, type: 'oneByOne' });
        }

        gsap.set(".gsap-from-bottom", {
            opacity: 0,
            y: 100
        });
        ScrollTrigger.batch(".gsap-from-bottom", {
            onEnter: batch => gsap.to(batch, {
                opacity: 1,
                y: 0,
                delay: .5,
                duration: .5,
                stagger: .25
            }),
        });

        gsap.set(".gsap-from-left", {
            opacity: 0,
            x: -100
        });
        ScrollTrigger.batch(".gsap-from-left", {
            onEnter: batch => gsap.to(batch, {
                opacity: 1,
                x: 0,
                delay: .5,
                duration: .5,
                stagger: .25
            }),
        });

        gsap.set(".gsap-from-right", {
            opacity: 0,
            x: 100
        });
        ScrollTrigger.batch(".gsap-from-right", {
            onEnter: batch => gsap.to(batch, {
                opacity: 1,
                x: 0,
                delay: .5,
                duration: .5,
                stagger: .25
            }),
        });

        //Smmoth scroll to

        $('.scroll-animation').on('click', function (e) {
            e.preventDefault();

            var href = $(this).attr('href');
            if (href) {
                $("html, body").animate({
                    scrollTop: $(href).offset().top - ( $('header').innerHeight() + 100 )
                }, 800);
            }
        });

        $('.scroll-animation a').on('click', function (e) {
            e.stopPropagation();
        });

        //Menu mobile toggle

        $(".menu-toggle").click(function(){
            $('.menu-overlay').fadeToggle();
            $(this).toggleClass("open");
        });

        //Linki posiadające podmenu - wyłączenie domyślnego zachowania

        $("#site-menu li.menu-item-has-children > a").on('click', function (e) {
            e.preventDefault();
        });

        $("#site-menu li.menu-item-has-children > ul," +
            "#site-menu li.menu-item-has-children > ul > li").on('click', function (e) {
            e.stopPropagation();
        });

        //Mainmenu - level 1

        $("#site-menu > li.menu-item-has-children").click(function () {

            if (window.matchMedia("(min-width: 1024px)").matches) {
                $(this).children('ul').fadeToggle({
                    start: function () {
                        $(this).css({
                            display: "flex"
                        })
                    }
                });
                $(this).toggleClass('open');

                $(this).siblings('li').children('ul').fadeOut();
                $(this).siblings('li').removeClass('open');
            } else {
                $(this).children('ul').slideToggle({
                    start: function () {
                        $(this).css({
                            display: "flex"
                        })
                    }
                });
                $(this).toggleClass('open');

                $(this).siblings('li').children('ul').slideUp();
                $(this).siblings('li').removeClass('open');
            }
        });

        //Hide mainmenu submenu by mouseleave
        $("#site-menu > li.menu-item-has-children > ul.dropdown-menu").mouseleave(function () {
            if (window.matchMedia("(min-width: 1024px)").matches) {
                $(this).fadeOut();
                $(this).parent().removeClass('open');
            }
        });

        //Hide mainmenu submenu by page scroll
        $(window).scroll(function () {
            if (window.matchMedia("(min-width: 1024px)").matches) {
                $("#site-menu > li.menu-item-has-children > ul.dropdown-menu").fadeOut();
                $("#site-menu > li.menu-item-has-children > ul.dropdown-menu").parent().removeClass('open');
            }
        });

        // Toggle lang picker dropdown menu on click
        $('a.current-lang').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).siblings('.dropdown-lang').slideToggle();
        });

        //Search trigger

        $('.search-trigger').click(function () {
            $(this).toggleClass('active');
            $('.search-panel').fadeToggle('active');
            return false;
        });

        $('#cf-message').click(function () {
            $(this).addClass('active');
        });

        function sendContactForm() {

            var cfEmail = $('input[name=cf-email]', '#cf-form').val();
            var cfMessage = $('textarea[name=cf-message]', '#cf-form').val();
            var cfUrl = $('input[name=cf-url]', '#cf-url').val();

            $.ajax({
                url: "/wp-admin/admin-ajax.php",
                method: "post",
                timeout: 10000,
                data: {
                    action: "send_email",
                    email: cfEmail,
                    message: cfMessage,
                    url: cfUrl
                },
                success: function () {
                    $('.ajax-success').slideDown();
                    $("#cf-form").trigger("reset");
                },
                error: function () {
                    $('.ajax-error').slideDown();
                },
                beforeSend: function () {
                    $('.ajax-success').slideUp();
                    $('.ajax-loading').slideDown();
                    $('.ajax-error').slideUp();
                },
                complete: function () {
                    $('.ajax-loading').slideUp();
                },
            });
        }

        function validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }

        $('#cf-submit').on('click', function (e) {
            e.preventDefault();
            $('.cf-error').hide();
            if ( (validateEmail($('#cf-email').val()) === false) || (!$('#cf-message').val()) || (!$('#cf-consent').is(':checked')) ) {

                if (validateEmail($('#cf-email').val()) === false) {
                    $('#cf-email').siblings('.cf-error').slideDown();
                }

                if (!$('#cf-message').val()) {
                    $('#cf-message').siblings('.cf-error').slideDown();
                }

                if (!$('#cf-consent').is(':checked')) {
                    $('#cf-consent').siblings('.cf-error').slideDown();
                }
            } else {
                sendContactForm();
            }
        });

    });
}(jQuery));
